import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const clientApi = {
  getClients: async ({ page = 1, perPage = 10, search = '', includeTrashed = false } = {}) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.CLIENTS}`, {
        params: { page, per_page: perPage, search, trashed: includeTrashed ? 'true' : 'false' },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching clients:', error);
      throw error;
    }
  },

  getClientByIdentifier: async (identifier) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.CLIENTS}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching client ${identifier}:`, error);
      throw error;
    }
  },

  createClient: async (clientData) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.CLIENTS}`, clientData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error creating client:', error);
      throw error;
    }
  },

  updateClient: async (identifier, clientData) => {
    try {
      clientData.append('_method', 'PUT'); // Method spoofing for PUT with FormData
      const response = await apiClient.post(`${API_ENDPOINTS.CLIENTS}/${identifier}`, clientData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating client ${identifier}:`, error);
      throw error;
    }
  },

  trashClient: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.CLIENTS}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error trashing client ${identifier}:`, error);
      throw error;
    }
  },

  restoreClient: async (identifier) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.CLIENTS}/${identifier}/restore`);
      return response.data;
    } catch (error) {
      console.error(`Error restoring client ${identifier}:`, error);
      throw error;
    }
  },

  permanentDeleteClient: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.CLIENTS}/${identifier}/permanent-delete`);
      return response.data;
    } catch (error) {
      console.error(`Error permanently deleting client ${identifier}:`, error);
      throw error;
    }
  },
};

export default clientApi;